import 'react-image-gallery/styles/css/image-gallery.css'

import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import ImageGallery from 'react-image-gallery'

import { WELL_BEING_SLIDERS } from '@/constants/sliders'

function Sliders() {
  const { t } = useTranslation('wellBeing')

  const handleScroll = (scrollTo: string): void => {
    const element = document.getElementById(scrollTo)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="relative w-full bg-gradient-to-r from-violet-25 to-violet-50 after:bg-violet-60 after:z-10 after:absolute after:top-0 after:w-full after:h-32">
      <div className="relative z-20 flex flex-col items-center py-12 bg-white rounded-3xl">
        <div className="p-4 text-center text-violet-225">
          <p className="text-2xl font-black uppercase xl:text-3xl 2xl:text-4xl">
            {t('sliders_title')}
          </p>
          <p className="text-2xl font-black uppercase xl:text-3xl 2xl:text-4xl">
            {t('sliders_title_1')}
          </p>
          <div className="relative flex items-center justify-center rounded-3xl">
            <div className="absolute top-0 z-50 -right-4 2sm:right-0 sm:right-4 w-14 md:w-28 xl:right-16 2xl:right-56 2xl:w-36 3xl:w-44 3xl:right-72">
              <Image
                alt={'slider_el'}
                src={`/images/well-being/slider-element.png`}
                height="100%"
                width="100%"
                layout="responsive"
                quality={75}
                loading="eager"
              />
            </div>
            <div className="px-2 py-8 sm:px-6 md:p-16 2xl:w-3/4 xl:w-11/12">
              <div className="overflow-hidden md:rounded-[3.25rem]">
                <ImageGallery
                  items={WELL_BEING_SLIDERS}
                  infinite
                  showPlayButton={false}
                  showFullscreenButton={false}
                  showThumbnails={false}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="md:px-16 lg:px-20 xl:px-32 2xl:px-48 3xl:px-80">
          <p className="text-2xl font-black text-center uppercase text-violet-225 xl:text-3xl 2xl:text-4xl">
            {t('sliders_digital_products')}
          </p>
          <div className="flex flex-col items-center justify-center w-full gap-8 py-20 md:gap-12 xl:py-40 md:flex-row xl:gap-14">
            <div className="bg-[#E39FB7] rounded-2xl w-5/6 md:w-4/5 2xl:w-1/2 relative">
              <div className="absolute w-32 md:w-40 -top-16 -right-5 2sm:-top-16 2md:-top-20 lg:-top-[5.25rem] xl:-top-24 md:-top-24 h-80 2xl:-top-32">
                <Image
                  alt={t('contact_1')}
                  src={`/images/well-being/book_2.png`}
                  width="100%"
                  height="130%"
                  layout="responsive"
                  quality={75}
                  loading="eager"
                />
              </div>
              <div className="flex flex-col items-start justify-center px-6 py-12 text-white">
                <p className="w-2/3 mb-6 text-sm font-extrabold md:w-1/2 md:text-base">
                  {t('sliders_left_title')}
                </p>
                <p className="text-xs font-medium md:text-sm">
                  {t('sliders_left_copy')}
                </p>
              </div>
            </div>
            <div className="bg-[#A4BBEB] rounded-2xl w-5/6 md:w-4/5 2xl:w-1/2 relative mt-8">
              <div className="absolute w-32 h-64 -right-5 -top-10 2sm:-top-12 md:-top-10 xl:-top-20 md:w-40 md:h-80 2xl:-top-28">
                <Image
                  alt={t('contact_2')}
                  src={`/images/well-being/book_1.png`}
                  height="130%"
                  width="100%"
                  layout="responsive"
                  quality={75}
                  loading="eager"
                />
              </div>
              <div className="flex flex-col items-start justify-center px-6 py-12 text-white">
                <p className="w-3/5 mb-6 text-sm font-extrabold md:w-1/2 md:text-base">
                  {t('sliders_right_title')}
                </p>
                <p className="text-xs font-medium md:text-sm">
                  {t('sliders_right_copy')}
                </p>
              </div>
            </div>
          </div>
        </div>
        <button
          onClick={() => handleScroll('contact')}
          className="px-4 py-2 font-bold text-white uppercase md:px-6 md:py-3 md:text-lg bg-green-60"
        >
          {t('button_banner')}
        </button>
      </div>
    </div>
  )
}

export default Sliders
